import { Injectable } from '@angular/core';
import { SocketEventWrapperService } from '../../socket-event-wrapper.service';
import {
    IWorkspaceProjectClientToServerEvents,
    IWorkspaceProjectServerToClientEvents,
} from '../../../../models/socket-events/workspace/workspace-project/workspace-project-events-model';

@Injectable()
export class WorkspaceProjectEventService {
    constructor(
        private socketEventWrapper: SocketEventWrapperService<
            IWorkspaceProjectClientToServerEvents,
            IWorkspaceProjectServerToClientEvents
        >
    ) {}

    onProjectUpdated() {
        return this.socketEventWrapper.fromEvent('onProjectUpdated');
    }

    onProjectCreated() {
        return this.socketEventWrapper.fromEvent('onProjectCreated');
    }
    onProjectDeleted() {
        return this.socketEventWrapper.fromEvent('onProjectDeleted');
    }
}
